module.exports = __webpack_public_path__ + "static/media/little_victory_1_filter.98c2bb29.png";